import { seoOgTwitterImage } from './SeoStore';

export const updateSeoOgTwitterImage = (value) => seoOgTwitterImage.update(oldValue => value);
